import React from 'react';
import { Avatar } from '@/components/ui/avatar';
import LargeText from './LargeText';

interface NameCardProps {
  title: string;
  description: string;
  avatarConfig: any; // You might want to define a more specific type for avatarConfig
}

const NameCard: React.FC<NameCardProps> = ({ title, description, avatarConfig }) => {
  return (
    <div className="card shadow-sm border border-gray-100 p-2 mt-2 rounded-md">
      <div className="flex flex-row gap-4 items-center justify-between">
        <div className="flex flex-row">
          <Avatar style={{ width: '1.5rem', height: '1.5rem' }} {...avatarConfig} />
          <div className="flex items-center justify-center">
            <span className="text-sm font-bold text-slate-600 pl-2">{title}</span>
          </div>
        </div>
      </div>
      <LargeText text={description} initialLines={2} />
    </div>
  )
};

export default NameCard;